import {Service, service} from "./di";

import {ToastLevel} from "../definitions/CommonDefinitions";

@service
export class ToastService extends Service {

	fireToastEvent(msg: string, level = ToastLevel.OK, closeable = true, target?: EventTarget): void {
		const node = target || window;
		node.dispatchEvent(new CustomEvent("flipp-toast", {
			cancelable: true,
			bubbles: true,
			detail: {
				message: msg,
				level,
				closeable
			}
		}));
	}

}
